import { render, staticRenderFns } from "./ProfesorHorario.vue?vue&type=template&id=696feb96&scoped=true&"
import script from "./ProfesorHorario.vue?vue&type=script&lang=js&"
export * from "./ProfesorHorario.vue?vue&type=script&lang=js&"
import style0 from "./ProfesorHorario.vue?vue&type=style&index=0&id=696feb96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696feb96",
  null
  
)

export default component.exports